import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class EmailService extends Service {
	constructor(injector: Injector) {
		super("Emails", injector);
	}
}